var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "payment-steps" },
    [
      _c("div", { staticClass: "steps-indicator" }, [
        _c(
          "div",
          {
            staticClass: "step",
            class: {
              active: _vm.currentStep === 1,
              completed: _vm.currentStep > 1,
            },
          },
          [
            _c("div", { staticClass: "step-number" }, [_vm._v("1")]),
            _vm._v(" "),
            _c("div", { staticClass: "step-label" }, [
              _vm._v(_vm._s(_vm.$t("auto.billingAddress"))),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", {
          staticClass: "step-line",
          class: { active: _vm.currentStep > 1 },
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "step",
            class: {
              active: _vm.currentStep === 2,
              completed: _vm.currentStep > 2,
            },
          },
          [
            _c("div", { staticClass: "step-number" }, [_vm._v("2")]),
            _vm._v(" "),
            _c("div", { staticClass: "step-label" }, [
              _vm._v(_vm._s(_vm.$t("auto.cardInfo"))),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _vm.errorMessage
        ? _c("a-alert", {
            staticStyle: { "margin-bottom": "20px" },
            attrs: {
              type: "error",
              message: _vm.errorMessage,
              "show-icon": "",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.currentStep === 1
        ? _c("BillingAddressForm", {
            attrs: { initialValues: _vm.billingForm },
            on: {
              submit: _vm.onBillingFormSubmit,
              cancel: function ($event) {
                return _vm.$emit("cancel")
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.currentStep === 2
        ? _c("CreditCardForm", {
            attrs: { initialValues: _vm.cardForm },
            on: { submit: _vm.onCardFormSubmit },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }